import { BOARD_SIZE } from '../../config/board.ts'
import { evalPosition } from '../eval.ts'
import type { Board, Color, Move, Player } from './types.ts'
import { pickBest } from './types.ts'

function opponent(c: Color): Color {
  return c === 'black' ? 'white' : 'black'
}

function hasAnyStone(board: Board): boolean {
  for (const row of board) for (const cell of row) if (cell !== 'empty') return true
  return false
}

// noiseRate の確率でランダム手、それ以外は greedy 相当の 1手先読み評価で選択
export function createNoisyGreedyPlayer(noiseRate: number): Player {
  const noisePct = Math.round(noiseRate * 100)
  return {
    id: `noisy${noisePct}`,
    name: `Noisy Greedy (${noisePct}% random)`,
    decide(board, color, { rng, forbidden, allowedMoves }) {
      if (allowedMoves && allowedMoves.length > 0) {
        return allowedMoves[Math.floor(rng() * allowedMoves.length)]
      }

      // 空マス列挙（forbidden 除外）
      const empties: Move[] = []
      for (let r = 0; r < BOARD_SIZE; r++) {
        for (let c = 0; c < BOARD_SIZE; c++) {
          if (board[r][c] !== 'empty') continue
          if (forbidden?.has(r * BOARD_SIZE + c)) continue
          empties.push({ row: r, col: c })
        }
      }
      if (empties.length === 0) return null

      // ノイズ判定: 確率的にランダム手を返す
      if (rng() < noiseRate) {
        return empties[Math.floor(rng() * empties.length)]
      }

      // greedy 相当: 盤面空なら中央固定
      if (!hasAnyStone(board)) {
        const center = Math.floor(BOARD_SIZE / 2)
        const centerKey = center * BOARD_SIZE + center
        if (!forbidden?.has(centerKey)) {
          return { row: center, col: center }
        }
      }

      const opp = opponent(color)
      const candidates: { score: number; item: Move }[] = empties.map(m => ({
        score: evalPosition(board, m.row, m.col, color, opp),
        item: m,
      }))
      return pickBest(candidates, rng)
    },
  }
}
